import {
  ViewBadges,
  ViewDiary,
  ViewForumCategories,
  ViewForumCategoryPosts,
  ViewMessage,
  ViewMilestones,
  ViewPostComments,
  ViewTipsHighlighted,
  ViewTipsOverview,
} from '../implementations';

const mappers = {
  views_block__diary_overview_block_1: ViewDiary,
  views_block__message_block_1: ViewMessage,
  views_block__forum_categories_default: ViewForumCategories,
  views_block__forum_category_posts_default: ViewForumCategoryPosts,
  views_block__forum_post_comments_default: ViewPostComments,
  views_block__tips_block_1: ViewTipsOverview,
  views_block__tips_block_2: ViewTipsHighlighted,
  views_block__milestones_block_1: ViewMilestones,
  views_block__badges_block_1: ViewBadges,
};

export default mappers;
